import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/plan',
    name: 'plan',
    component: () => import('../views/list.vue')
  },
  {
    path: '/epc',
    name: 'epc',
    component: () => import('../views/list.vue')
  },
  {
    path: '/furniture',
    name: 'furniture',
    component: () => import('../views/list.vue')
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/list.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/list.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/list.vue')
  },
  {
    path: '/planinfo',
    name: 'planinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/furnitureinfo',
    name: 'furnitureinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/caseinfo',
    name: 'caseinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/newsinfo',
    name: 'newsinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/epcinfo',
    name: 'epcinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/serviceinfo',
    name: 'serviceinfo',
    component: () => import('../views/info.vue')
  },
  {
    path: '/about1',
    name: 'about1',
    component: () => import('../views/info.vue')
  },
  {
    path: '/about2',
    name: 'about2',
    component: () => import('../views/info.vue')
  },
  {
    path: '/about3',
    name: 'about3',
    component: () => import('../views/info.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
